export default __webpack_public_path__ + "static/scams-hub-responsible-disclosure-hero-bbd0de8f8a9bfcdefa9ccda9475bf2c7.webp";